import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col} from "react-bootstrap";
import {Link} from "react-router-dom";
import reactHtmlParser from "react-html-parser";
import {Img} from "../Img";
import {bold, darkBlue, text, white} from "../../styles/globalStyleVars";

const MyComponent = ({img, title, deg, handlePopup, description}) => {
    return (
        <StyledComponent onClick={() => handlePopup && handlePopup({ title, img, deg, description })} className={'team-single'}>
            <div className="team-single__img">
                <Img src={img}/>
            </div>
            <div className="team-single__content">
                {title && <p className={'split-up'}>{reactHtmlParser(title)}</p>}
                {deg && <p className={'split-up'}>{reactHtmlParser(deg)}</p>}
            </div>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
  position: relative;
  cursor: pointer;

  .team-single__img {
    position: relative;
    padding-top: calc(330 / 270 * 100%);
    .global-image{
      overflow: hidden;
      img{
        transform: scale(1.01);
        transition: 1.4s ease;
      }
    }
    &:hover {
      .global-image img{
        transform: scale(1.06) !important;
      }
    }
  }

  .team-single__content {
    margin-top: 20px !important;

    p {      
      &:first-child{
        font-family: ${bold};
        color: ${darkBlue};
      }
      &:last-child{
        color: ${text};
      }
    }
  }

  //&:hover {
  //  .team-single__img img {
  //    transform: scale(1.04);
  //  }
  //}
`;

export default MyComponent;
